import { useState } from "react";

export function useSteps(initialStep: number) {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const handleNext = () => {
    setCurrentStep((curr) => curr + 1);
  };

  const handlePrev = () => {
    setCurrentStep((curr) => curr - 1);
  };

  return {
    currentStep,
    handleNext,
    handlePrev,
  };
}
